import React from 'react'
import { Container } from 'Common'
import { Wrapper, Flex, Links, Details } from './styles'
import social from './social.json'

export const Footer = () => (
	<Wrapper>
		<Flex as={Container}>
			<Details>
				<h2>Ping Cheng</h2>
			</Details>
			<Links>
				{social.map(({ link, icon }, i) => (
					<a
						key={i}
						href={link}
						target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#000' }}
					>
						<i className={`fab fa-${icon}`} />
					</a>
				))}
			</Links>
		</Flex>
	</Wrapper>
)
